export const getMasterLangugageList = 'community/getMasterLangugageList';
export const getCommunityList = 'community/getCommunityList';
export const getCommunityWiseLanguages = 'community/getCommunityWiseLanguages'
export const communitywiseLabels = 'community/getTranslationsByCommunityId';
export const setupDetails = 'community/setupDetails';
export const getCommunityBrandingByCommunityId = 'community/getCommunityBrandingByCommunityId';
export const getTemplatesByCommunityId = 'community/getTemplatesByCommunityId';
export const contentListByCommunityId = 'cms/contentListByCommunityId';

export const getRegistrationQuestions = 'registration/getRegistrationQuestions';

export const getStaticContent = 'cms/getStaticContent';
export const getRoleWiseContent  = 'cms/getRoleWiseContent ';
export const likeContent  = 'cms/likeContent ';
export const unlikeContent  = 'cms/unlikeContent';
export const addCommentToContent  = 'cms/addCommentToContent';
export const getContentWiseComments  = 'cms/getContentWiseComments';

export const getServiceByCommunityId = 'getInvolved/getServiceByCommunityId';
export const getQuestionsByServiceId = 'getInvolved/getQuestionsByServiceId';

export const addApplicant = 'user/addApplicant';
export const updateUserProfile = 'user/updateUserProfile';
export const updatefcmIdForUserUsingPOST = 'user/updatefcmIdForUser';
export const getUserProfile = 'user/getUserProfile';
// export const getApplicantByCommunityId = 'user/getApplicantByCommunityId';
export const getApplicantByCommunityId = 'user/getUsersByCommunityId';
export const addChatHistoryUsingUserId = 'user/addChatHistoryUsingUserId';
export const addChatHistoryOnGroupUsingUserId = 'user/addChatHistoryOnGroupUsingUserId';
export const updateChatHistoryOnGroupUsingUserId = 'user/updateChatHistoryOnGroupUsingUserId';
export const getForumGroupMsgCountForUserByCommunityId = 'user/getForumGroupMsgCountForUserByCommunityId';
export const checkIfForumchatIsApproved = 'user/checkIfForumchatIsApproved';
export const getListApplicantForChatApproval = 'user/getListApplicantForChatApproval';
export const approveApplicantForForumChat = 'user/approveApplicantForForumChat';
export const inactiveUser = 'user/inactiveUser';
export const checkIfApplicantExists = 'user/checkIfApplicantExists';
export const getCalenderRemaindersForUser = 'user/getCalenderRemaindersForUserApp';

export const getEmergencyContacts = 'user/getEmergencyContacts';
export const saveEmergencyContacts = 'user/saveEmergencyContacts';

export const getVoicBotStatus = 'community/getCommunityChannelConfiguration'
export const getTriggerWordsForVoiceBot = 'voicebot/getTriggerWordsForVoiceBot';
export const getPhrasesForVoiceBot = 'voicebot/getPhrasesForVoiceBot';

export const getComponentList = 'roleAuth/getComponentList';
export const getRoleDetails = 'roleAuth/getRoleDetails';

export const getallnearme = 'nearme/getallnearme';
export const searchnearme = 'nearme/searchNearmeByCommunityId';
export const saveupdatenearmerating = 'nearme/addNearmeRating';
export const getNearMeTypes = 'nearme/getTypesByCommunityId';
export const getStateListForNearmeByCommunityId = 'nearme/getStateListForNearmeByCommunityId';

export const addCaseForService = 'caseSetForService/addCaseForService';
export const getCaseListForService = 'caseSetForService/getCaseListForService';
export const getCaseDetailsForService = 'caseSetForService/getCaseDetailsForService';

export const getComponentWiseRoleDetails = 'roleAuth/getComponentWiseRoleDetails';

export const getSectionBySurveyId = 'survey/getSectionBySurveyId';
export const getSurveySectionQuestionsBySectionId = 'survey/getSurveySectionQuestionsBySectionId';
export const getSurveyByCommunityId = 'survey/getSurveyByCommunityId';
export const getQuestionsBySurveyId = 'survey/getQuestionsBySurveyId';
export const addCaseSetForSurveyUsingPOST = 'caseSetSurvey/addCaseSetForSurvey';
export const getCaseSetForSurveyByUserId = 'caseSetSurvey/getCaseSetForSurveyByUserId';
export const getCaseSetSurveyDetails = 'caseSetSurvey/getCaseSetSurveyDetails';
export const ChangeCaseStatusForService = 'caseSetForService/ChangeCaseStatusForService';
export const dashboardLogin = 'community/dashboardLogin';
export const IdentifyUserType = 'community/IdentifyUserType';
export const ResetPin = 'user/ResetPin';
export const ResetPassword ='user/resetPassword'
export const getAppVersion = 'community/getAppVersion';



export const getAvatarByCommunityId = 'getConnected/getAvatarByCommunityId';
export const getForumChatGroupByCommunityId = 'getConnected/getForumChatGroupByCommunityId';

export const remainderNotificationUsingWhatsapp = 'whatsapp/remainderNotificationUsingWhatsapp';

export const sendPushNotification = 'https://fcm.googleapis.com/fcm/send';




